import Quagga from 'quagga'; // ES6

window.initialiseScanner = function(parentElement, disableInputOnDone = true, detectionCallback = null) {
  Quagga.init({
    inputStream: {
      name: "Live",
      type: "LiveStream",
      target: '#interactive' // Or '#yourElement' (optional)
    },
    decoder: {
      readers: [{
        format: ["code_128_reader"],
        config: {}
      }]
    },
    locate: true,
  }, function(err) {
    if (err) {
      console.log(err);
      return
    }
    console.log("Initialization finished. Ready to start");
    Quagga.start();
  });

  Quagga.onProcessed(function(result) {
    var drawingCtx = Quagga.canvas.ctx.overlay,
      drawingCanvas = Quagga.canvas.dom.overlay;

    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
        result.boxes.filter(function(box) {
          return box !== result.box;
        }).forEach(function(box) {
          Quagga.ImageDebug.drawPath(box, {
            x: 0,
            y: 1
          }, drawingCtx, {
            color: "green",
            lineWidth: 2
          });
        });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, {
          x: 0,
          y: 1
        }, drawingCtx, {
          color: "#00F",
          lineWidth: 2
        });
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(result.line, {
          x: 'x',
          y: 'y'
        }, drawingCtx, {
          color: 'red',
          lineWidth: 3
        });
      }
    }
  });
  Quagga.onDetected(function(result) {
    if (result.codeResult && result.codeResult && parentElement.querySelector('input[name="reference"]')) {
      parentElement.querySelector('input[name="reference"]').value = result.codeResult.code;
      Quagga.stop();
      document.querySelector('#scanner_modal').querySelector('#scannerSearching').classList.add('is-hidden');
      document.querySelector('#scanner_modal').querySelector('#scannerFound').classList.remove('is-hidden');
      setTimeout(() => {
        document.querySelector('#scanner_modal').classList.remove('is-active');

        // Disable input
        parentElement.querySelector('.scan').classList.remove('is-loading');
        if (disableInputOnDone) {
          let refField = parentElement.querySelector('input[name="reference"]');
          refField.disabled = true;
          refField.readOnly = true;
          refField.blur();
        }

        if (detectionCallback) {
          detectionCallback();
        }
      }, 1500);
    }
  });
}

window.killCamera = function() {
  Quagga.stop();
  document.querySelector('#scanner_modal').classList.remove('is-active');

  // Disable input
  document.querySelector('.scan').classList.remove('is-loading');
  let refField = document.querySelector('input[name="reference"]');
  refField.disabled = true;
  refField.readOnly = true;
  refField.blur();
}



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/barcode-reader.js